"use client";

import { useTranslations } from "next-intl";

const FounderMessage = () => {
  const t = useTranslations("team");

  return (
    <div className="gs--page-column pt-16 pb-8">
      <div className="text-ring flex flex-col items-center justify-center gap-4 text-center">
        <p className="italic">{t("founderMessage")}</p>
        <p className="font-bold">{t("founder")}</p>
      </div>
    </div>
  );
};

export default FounderMessage;
